for (let i=0; i < 30; i++){
  $("#filter-png"+i).click(function(){  
    $(".product-mobile-box").css("display", "none");
    $(".quick-product__btn-mbl").css("display", "block");
    $(".product-mobile-close").css("display", "block");
 $("#popupvgr-"+i).show(); 
 });  
}

function sort() {
if(screen.width<990){
  $(".sort-filter").css("display", "block");
  $("#filter-text").css("display", "none");
  $(".mobile-collection-title").css("display", "none");
}
}

function desktopsort() {
var x = document.getElementById("p2").getAttribute("aria-expanded"); 
if (x == "true") 
{
      document.getElementById("p2").setAttribute("style", "text-decoration:none");

x = "false"
$(".desktop-sort").css("display", "none");
} else {
   document.getElementById("p2").setAttribute("style", "text-decoration:underline");
  $(".desktop-sort").css("display", "inline-flex");
x = "true"
}
document.getElementById("p2").setAttribute("aria-expanded", x);
}

function mblclose(){
$(".product-mobile-box").css("display", "none");
$(".product-mobile-close").css("display", "none");
}

function filteropensort() {
    // if filter was previously opened, triggering this function will result 
  // in closing filter
  // we need to make sure MainContent does not have any marginTop
  const mainContent =  document.querySelector('#MainContent')
  const hasMargin = mainContent.style.marginTop;
  if (hasMargin) {
    mainContent.style.marginTop = 0;
  }
$("#CollectionSidebar").css("display", "none");
$("#filter-text").css("display", "inline-flex");
$(".desktop-filter-title").css("display", "inline-flex");
$(".desktop-sort").css("display", "inline-flex");
}

var vgx = document.querySelectorAll(".tag__input");
let kraks = [];
vgx.forEach(el=>{
el.addEventListener('click',(event)=>{

const span = event.target.nextElementSibling;
    if (span) {
      span.classList.toggle('checked');
    }
let color = encodeURIComponent(event.target.value.trim());
kraks.push(`${event.target.name}=${color}&`)  
console.log(kraks)
});
});

function popupclose(){
$(".wrap").css("display", "none");
$('.wrap').removeClass("great");
}

$('.open-label').on('click', function(){
if(screen.width<990){
$('.wrap').addClass('great');
$('.wrap').css("display", "block");
}
});

// Desktop
// $(".filter-size").css("display", "none"); 
$("#down").on("click",function(){ 
$("#filter-text").css("display", "inline-flex"); 
$("#CollectionSidebar").css("display", "none");
$("#filter-open-text").css("display", "none"); 
$(".filter-open-sort").css("display", "none");
$(".desktop-filter-title").css("display", "inline-flex");
$("#StickyHeaderWrap").css("display", "block");
// $(".filter-size").css("display", "block"); 

var url = window.location.href + "?" +kraks;
const parts = url.split("?");
const newUrl = parts[0] + (parts.length > 1 ? "?filter.v.availability=1&" + parts.slice(1).map(part => part.replace(/\?/g, '')).join('') : '');
var clear = newUrl.replaceAll(',', ''); 

window.location.href = clear;
console.log(window.history.pushState("object or string","Title",clear));

if(screen.width<750){
  myPopup.classList.remove("show"); 
  $("#filter-text").css("display", "none");
  $(".desktop-filter-title").css("display", "none");
  $(".mobile-collection-title").css("display", "inline-flex");
}
})

// Mobile
$("#down-mobile").on("click",function(){ 
$("#filter-text").css("display", "inline-flex"); 
$("#CollectionSidebar").css("display", "none");
$("#filter-open-text").css("display", "none"); 
$(".filter-open-sort").css("display", "none");
$(".desktop-filter-title").css("display", "inline-flex");
$("#StickyHeaderWrap").css("display", "block");

var url = window.location.href+"?"+kraks;

  const parts = url.split("?");
  const newUrl = parts[0] + (parts.length > 1 ? "?filter.v.availability=1&" + parts[1].replace(/\?/g, '') : '')
  var clear = newUrl.replaceAll(',', '');  
  
  window.location.href = clear;
})